import React from 'react';

const Height15 = () => {
    return (
        <div className="h-[15px] my-5"></div>
    );
}

export default Height15;
